var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-table',{attrs:{"url":_vm.url,"title":"تسویه های تسهیم","fields":_vm.fields,"params":_vm.params,"detailUrl":_vm.detailUrl,"excelroute":'asdasd',"btns":_vm.btns},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }